import { render } from "./ReceiptAttachmentsModal.vue?vue&type=template&id=27c9a349"
import script from "./ReceiptAttachmentsModal.vue?vue&type=script&lang=js"
export * from "./ReceiptAttachmentsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__